import apiService from './api/api.service';
import { logger } from '@utils/logger';

class OTPService {
  /**
   * Send phone OTP
   */
  async sendPhoneOTP(phone) {
    try {
      const response = await apiService.post('/auth/send-phone-otp', { phone });
      logger.info('Phone OTP sent successfully');
      return response;
    } catch (error) {
      logger.error('Send phone OTP failed', error);
      throw error;
    }
  }

  /**
   * Verify phone OTP
   */
  async verifyPhoneOTP(userId, otp) {
    try {
      const response = await apiService.post('/auth/verify-phone', {
        userId,
        otp
      });
      logger.info('Phone OTP verified successfully');
      return response;
    } catch (error) {
      logger.error('Phone OTP verification failed', error);
      throw error;
    }
  }

  /**
   * Send email OTP
   */
  async sendEmailOTP(userId, email, firstName, lastName) {
    try {
      const response = await apiService.post('/auth/send-email-otp', {
        userId,
        email,
        firstName,
        lastName
      });
      logger.info('Email OTP sent successfully');
      return response;
    } catch (error) {
      logger.error('Send email OTP failed', error);
      throw error;
    }
  }

  /**
   * Verify email OTP
   */
  async verifyEmailOTP(userId, otp) {
    try {
      const response = await apiService.post('/auth/verify-email', {
        userId,
        otp
      });
      logger.info('Email OTP verified successfully');
      return response;
    } catch (error) {
      logger.error('Email OTP verification failed', error);
      throw error;
    }
  }


  /**
   * Resend OTP
   */
  async resendOTP(userId, type) {
    try {
      const response = await apiService.post('/auth/resend-otp', {
        userId,
        type // 'email' or 'phone'
      });
      logger.info(`OTP resent successfully for ${type}`);
      return response;
    } catch (error) {
      logger.error('Resend OTP failed', error);
      throw error;
    }
  }
}

export const otpService = new OTPService();
export default otpService;
